import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function GallerySection() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/9FViNuEXQAEaWy1qFVrn83/y4.png',
    alt: 'Pohled na budovu z ulice',
    className: 'col-span-1 md:col-span-2 aspect-[21/9]'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/cv1wtq2fqZCj6hSXE5Te1E/y5.png',
    alt: 'Detailní pohled na balkony',
    className: 'col-span-1 aspect-[4/3]'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/dFfdPhD6t68BCbFttac4wK/y14.png',
    alt: 'Pohled do vnitrobloku',
    className: 'col-span-1 aspect-[4/3]'
  }];
  return <section id="galerie" className="py-24 bg-white" data-id="element-120">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-123">
            Galerie
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-124">
            Prohlédněte si vizualizace vašeho budoucího domova
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-125">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`relative group overflow-hidden rounded-xl cursor-pointer ${img.className}`} onClick={() => setSelectedImage(img.url)} data-id="element-126">
              <img src={img.url} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-127" />
              <div className="absolute inset-0 bg-primary/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-128">
                <span className="text-white font-medium tracking-wider uppercase border border-white/50 px-6 py-2 rounded-sm backdrop-blur-sm" data-id="element-129">
                  Zobrazit
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-130">
          <a href="#cela-galerie" className="inline-block bg-primary hover:bg-primary-light text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-131">
            Zobrazit celou galerii
          </a>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-132">
        {selectedImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 md:p-12" onClick={() => setSelectedImage(null)} data-id="element-133">
            <button className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors" onClick={() => setSelectedImage(null)} data-id="element-134">
              <XIcon className="w-8 h-8" data-id="element-135" />
            </button>
            <motion.img initial={{
          scale: 0.9
        }} animate={{
          scale: 1
        }} exit={{
          scale: 0.9
        }} src={selectedImage} alt="Zvětšený náhled" className="max-w-full max-h-full object-contain rounded-md shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-136" />
          </motion.div>}
      </AnimatePresence>
    </section>;
}